import React from 'react'
import Head from 'next/head'
export default function Layout({ children, title }) {
  
    return (
        <React.Fragment>
            <Head>
                <title>Cyberno - {title}</title>
                <meta name="description" content="برنامه های تلفن های هوشمند ، مانند برنامه های رایانه های شخصی ، برای مقاومت در برابر حملات به اقدامات امنیتی زیادی نیاز دارند. متأسفانه ، بیشتر برنامه های کاربردی برای سیستم عامل های تلفن همراه اکنون بدون آزمایش نفوذ و نکات اساسی امنیتی وارد بازار می شوند. " />
                <meta name="keywords" content="" />
                <meta httpEquiv="content-language" content="fa"></meta>
            </Head>
            {children}
        </React.Fragment>
    )
}
